import { render, staticRenderFns } from "./yongyaoteyixingfenxi.vue?vue&type=template&id=17f89e1f&"
import script from "./yongyaoteyixingfenxi.vue?vue&type=script&lang=ts&"
export * from "./yongyaoteyixingfenxi.vue?vue&type=script&lang=ts&"
import style0 from "./yongyaoteyixingfenxi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports